import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface AffiliationCardProps {
  id: string;
  name: string;
  location: string;
  image: string;
  desc: string;
}
export function AffiliationCard({
  id,
  name,
  location,
  image,
  desc
}: AffiliationCardProps) {
  return <div className="flex flex-col bg-white border border-club-border rounded-sm overflow-hidden group" data-id="element-105">
      <div className="aspect-[4/3] overflow-hidden relative" data-id="element-106">
        <img src={image} alt={name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-107" />
      </div>
      <div className="p-6 flex flex-col flex-grow" data-id="element-108">
        <div className="flex items-center gap-2 text-xs font-medium text-club-gold uppercase tracking-wider mb-2" data-id="element-109">
          <MapPin size={14} data-id="element-110" /> {location}
        </div>
        <h3 className="text-2xl mb-3 group-hover:text-club-green transition-colors" data-id="element-111">
          {name}
        </h3>
        <p className="text-club-ink/70 text-sm mb-6 line-clamp-2 flex-grow" data-id="element-112">
          {desc}
        </p>
        <Link to={`/affiliated-clubs/${id}`} className="inline-flex items-center text-sm font-medium text-club-green group-hover:text-club-gold transition-colors mt-auto" data-id="element-113">
          View Details <ArrowRight size={14} className="ml-1" data-id="element-114" />
        </Link>
      </div>
    </div>;
}